"use strict"

const TextField = Vue.extend({
    template: "#textfield",
    props: {
        allConfirmed: {
            type: Boolean,
            required: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        label: {
            type: String,
            required: true,
        },
        isModal: {
            type: Boolean,
            required: false,
            default: false,
        },
        model: {
            type: String,
            required: false,
        },
        pattern: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: false,
        },
        validationError: {
            type: String,
            required: false,
        },
        name: {
            type: String,
            required: false,
            default: "",
        },
        matomo: {
            type: String,
            required: false,
            default: "",
        }
    },
    data() {
        return {
            userConfirmed: false,
            value: null,
        }
    },
    watch: {
        allConfirmed(v) {
            this.userConfirmed = v
        },
        model(v) {
            this.value = v
        },
        value(v) {
            this.$emit("update:model", v)
        },
    },
    mounted() {
        this.value = this.model
        this.userConfirmed = this.allConfirmed
    },
})